import { render, staticRenderFns } from "./NetPremiumAmount.vue?vue&type=template&id=30441c86"
import script from "./NetPremiumAmount.vue?vue&type=script&lang=js"
export * from "./NetPremiumAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports